import { TableColumn } from '@scale/scaleui';

import { useQuery } from 'react-query';
import {
  StatContextState,
  apiStatContextSelector,
  dateRangeSelector,
  podTypeFilterSelector,
  projectIdSelector,
  useStatContextStore,
} from 'react-scale/components/ExpertManagement/stores/statContext.store';
import { shallow } from 'zustand/shallow';
import { makeLoadingRowCellFunction } from './LoadingTable';
import { ManagerSummaryDataColumns, ManagerTable } from './ManagerTable';
import { fetchManagerAggregationData, fetchManagerAggregationDataShort } from './api';

const SHORT_COLUMNS = ['name', 'role'];
const ManagerSummaryDataColumnsShort: TableColumn[] = ManagerSummaryDataColumns.map(column => {
  if (SHORT_COLUMNS.includes(column.id)) {
    return column;
  }
  return {
    ...column,
    cell: makeLoadingRowCellFunction(3),
  };
});

const selectors = (state: StatContextState) => ({
  projectId: projectIdSelector(state),
  dateRange: dateRangeSelector(state),
  podTypeFilter: podTypeFilterSelector(state),
  apiStatContext: apiStatContextSelector(state),
});

export const ManagerAggregationTable: React.FC = () => {
  const { projectId, dateRange, podTypeFilter, apiStatContext } = useStatContextStore(
    selectors,
    shallow,
  );
  const {
    data: shortData,
    isLoading: shortDataIsLoading,
    refetch: shortRefetch,
  } = useQuery(
    ['managerAggregationDataShort', projectId, dateRange, podTypeFilter],
    () => fetchManagerAggregationDataShort(apiStatContext),
    {
      staleTime: 60 * 60 * 1000,
    },
  );
  const {
    data: fullData,
    isLoading: fullDataIsLoading,
    refetch: fullRefetch,
  } = useQuery(
    ['managerAggregationData', projectId, dateRange, podTypeFilter],
    () => fetchManagerAggregationData(apiStatContext),
    {
      staleTime: 60 * 60 * 1000,
    },
  );

  const [data, isLoading, columns] = fullDataIsLoading
    ? [shortData, shortDataIsLoading, ManagerSummaryDataColumnsShort]
    : [fullData, fullDataIsLoading, ManagerSummaryDataColumns];

  return (
    <ManagerTable
      columns={columns}
      data={data}
      isLoading={isLoading}
      reloadData={() => {
        shortRefetch();
        fullRefetch();
      }}
    />
  );
};
